export default __webpack_public_path__ + "static/media/favicon.656d4b9e.ico";